import {RESULT_RECEIVED} from "./ResultActions";

const initialState = {
  received: false,
  error: null,
  result: null,
  orderIntent: null,
  threeDsAuthenticationResult: null,
  paymentInstrument: null,
  executeRequired: false,
  product: null
};

export function result(state = initialState, action) {
  switch (action.type) {
    case RESULT_RECEIVED:
      return {
        received: true,
        error: action.error,
        result: action.result,
        orderIntent: action.orderIntent,
        threeDsAuthenticationResult: action.threeDsAuthenticationResult,
        paymentInstrument: action.paymentInstrument,
        executeRequired: !!action.executeRequired,
        product: action.product
      };
    default:
      return state;
  }
};

export const getError = state => {
  return state.result.error;
};

export const getResult = state => {
  return state.result.result;
};

export const getOrderIntent = state => {
  return state.result.orderIntent;
};

export const getThreeDsAuthenticationResult = state => {
  return state.result.threeDsAuthenticationResult;
};

export const getPaymentInstrument = state => {
  return state.result.paymentInstrument;
};

export const isExecutionRequired = state => {
  return state.result.executeRequired;
};

export const getProduct = state => {
  return state.result.product;
};



// WEBPACK FOOTER //
// ./src/result/ResultReducers.js